import { gql } from '@apollo/client';

const SET_ORG_UNIT_SHARED_DATA = gql`
  mutation SetOrgUnitSharedData($data: ShareMddapOrgUnitData!) {
    shareMddapOrgUnitDataWithFda(data: $data)
  }
`;

export default SET_ORG_UNIT_SHARED_DATA;
